// Traduction d'une clé — module pur (Phase 95, D-07 couche 3).
//
// Pas de hook, pas de contexte : le provider (plan 95-04) fournit `lang` et le
// catalogue chargé. Le français est toujours la base, donc une clé absente du
// catalogue étranger rend du texte lisible et JAMAIS la clé technique à
// l'écran. Le trou est signalé en développement seulement.
//
// La garde teste le mode de build, pas le drapeau `DEV` : c'est la forme déjà
// employée par lib/sentry.ts et components/Footer.tsx, l'autre n'apparaît
// nulle part dans ce dépôt.
// Refs: phase 95.
import { fr } from './locales/fr'
import type { Catalogue, Lang, MsgKey } from './types'

export function translate(
  key: MsgKey,
  lang: Lang,
  catalogue: Catalogue | null,
  vars?: Record<string, string | number>,
): string {
  let raw: string = fr[key]

  // `catalogue === null` = chunk pas encore chargé ou échec de chargement :
  // repli français silencieux, ce n'est pas une anomalie de catalogue.
  if (lang !== 'fr' && catalogue) {
    const hit = catalogue[key]
    if (hit !== undefined) {
      raw = hit
    } else if (import.meta.env.MODE !== 'production') {
      console.error(
        `[i18n] clé absente du catalogue "${lang}" : ${key} — repli français`,
      )
    }
  }

  // Variable absente : on laisse le littéral `{nom}` plutôt que `undefined`.
  return vars
    ? raw.replace(/\{(\w+)\}/g, (_match, name: string) =>
        name in vars ? String(vars[name]) : `{${name}}`,
      )
    : raw
}
